"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWizard = void 0;
var react_1 = require("react");
var getInitialStep_1 = require("./journey/dependencies/getInitialStep");
var nextStep_1 = require("./journey/nextStep");
var previousStep_1 = require("./journey/previousStep");
var goToStep_1 = require("./journey/goToStep");
var jumpSteps_1 = require("./journey/jumpSteps");
var initialize_1 = require("./journey/initialize");
var useWizard = function (options) {
    var initialStep = getInitialStep_1.getInitialStep(options);
    var _a = react_1.useState([initialStep]), history = _a[0], setHistory = _a[1];
    var wizard = {
        nextStep: nextStep_1.nextStep(history, setHistory)(history[history.length - 1], options),
        previousStep: previousStep_1.previousStep(setHistory)(history[history.length - 1], options),
        initialize: initialize_1.initialize(setHistory, initialStep),
        jumpSteps: jumpSteps_1.jumpSteps(setHistory, options),
        goToStep: goToStep_1.goToStep(setHistory),
        history: history,
    };
    return [history[history.length - 1], wizard];
};
exports.useWizard = useWizard;
//# sourceMappingURL=useWizard.js.map